module.exports = __webpack_public_path__ + "static/phone-app-c13b28e79a8807d2ed0a3d1e9a718f96.jpg";